import type { VacancySyncState } from "./types";

type JobSyncClientsListParams = {
  tenantId: string;
  page?: number;
  pageSize?: number;
  integrationName: string;
  search?: string;
  moduleStatus?: "active" | "inactive" | null;
  orderBy?: string | null;
  descending?: boolean | null;
};

type JobSyncVacanciesListParams = {
  integrationName: string;
  clientId: string;
  syncState?: VacancySyncState | null;
  page?: number;
  pageSize?: number;
};

export const jobSyncQueryKeys = {
  all: ["integrations"] as const,
  byIntegration: (integrationName: string) =>
    [...jobSyncQueryKeys.all, integrationName] as const,
  byModule: (integrationName: string) =>
    [...jobSyncQueryKeys.byIntegration(integrationName), "job-sync"] as const,
  clients: (integrationName: string) =>
    [...jobSyncQueryKeys.byModule(integrationName), "clients"] as const,
  clientsList: (params: JobSyncClientsListParams) =>
    [
      ...jobSyncQueryKeys.clients(params.integrationName),
      params.tenantId,
      params.page,
      params.pageSize,
      params.search,
      params.moduleStatus,
      params.orderBy,
      params.descending,
    ] as const,
  vacancies: (integrationName: string) =>
    [...jobSyncQueryKeys.byModule(integrationName), "syncOverview"] as const,
  vacanciesList: (params: JobSyncVacanciesListParams) =>
    [
      ...jobSyncQueryKeys.vacancies(params.integrationName),
      params.clientId,
      params.syncState,
      params.page,
      params.pageSize,
    ] as const,
  feedRegistration: (integrationName: string, clientId: string | undefined) =>
    [
      ...jobSyncQueryKeys.byModule(integrationName),
      "feed-registration",
      clientId,
    ] as const,
  feedComparison: (integrationName: string, clientId: string | undefined) =>
    [
      ...jobSyncQueryKeys.byModule(integrationName),
      "feed-registration-comparison",
      clientId,
    ] as const,
  feedContent: (integrationName: string) =>
    [...jobSyncQueryKeys.byModule(integrationName), "feed-content"] as const,
  feedContentByUrl: (
    integrationName: string,
    feedUrl: string | null | undefined
  ) => [...jobSyncQueryKeys.feedContent(integrationName), feedUrl] as const,
};
